// extracted by mini-css-extract-plugin
export default {"memberStatus":"EventCard_memberStatus__SpmAT","card":"EventCard_card__sgPjF","event-note-div":"EventCard_event-note-div__usQmt"};